import { render, staticRenderFns } from "./Compound.vue?vue&type=template&id=0b97a856&"
import script from "./Compound.vue?vue&type=script&lang=js&"
export * from "./Compound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports